import { SaleType } from "constants/sale";

export enum DocumentType {
  NVD = "NVD",
  ANIMAL_HEALTH_STATEMENT = "Animal Health Statement",
  OTHER = "Other",
  KILL_SHEET = "Feedback/Kill Sheet",
  INSURANCE_CLAIM = "Insurance Claim",
  INTERNAL_DOCUMENTATION = "Internal Documentation",
  SUPPORTING_DOCUMENTATION = "Supporting Documentation",
  IMAGE = "image",
  VIDEO = "video",
  SUNDRY = "Sundry",
}

export const MediaDocumentTypes = [
  DocumentType.IMAGE,
  DocumentType.VIDEO,
] as const;

export type MediaDocumentType = (typeof MediaDocumentTypes)[number];

export const OtherDocumentTypes = [DocumentType.SUNDRY] as const;

export type OtherDocumentType = (typeof OtherDocumentTypes)[number];

export const NVDRelatedDocumentTypes = [
  DocumentType.NVD,
  DocumentType.ANIMAL_HEALTH_STATEMENT,
  DocumentType.OTHER,
  DocumentType.KILL_SHEET,
  DocumentType.INSURANCE_CLAIM,
  DocumentType.INTERNAL_DOCUMENTATION,
  DocumentType.SUPPORTING_DOCUMENTATION,
] as const;

export type NVDRelatedDocumentType = (typeof NVDRelatedDocumentTypes)[number];

export interface DocumentTypeOption {
  label: string;
  value: DocumentType;
  saleTypes?: SaleType[];
}

export const NVDDocumentTypeOptions: DocumentTypeOption[] = [
  {
    label: DocumentType.NVD,
    value: DocumentType.NVD,
  },
  {
    label: DocumentType.ANIMAL_HEALTH_STATEMENT,
    value: DocumentType.ANIMAL_HEALTH_STATEMENT,
  },
  {
    label: DocumentType.OTHER,
    value: DocumentType.OTHER,
  },
  {
    label: DocumentType.KILL_SHEET,
    value: DocumentType.KILL_SHEET,
    saleTypes: [SaleType.OVER_HOOKS],
  },
  {
    label: DocumentType.INSURANCE_CLAIM,
    value: DocumentType.INSURANCE_CLAIM,
  },
  {
    label: DocumentType.SUPPORTING_DOCUMENTATION,
    value: DocumentType.SUPPORTING_DOCUMENTATION,
  },
  {
    label: DocumentType.INTERNAL_DOCUMENTATION,
    value: DocumentType.INTERNAL_DOCUMENTATION,
  },
];

export enum DeclarationType {
  S0413 = "S0413",
  S0720 = "S0720",
  C0413 = "C0413",
  C0720 = "C0720",
  E0413 = "E0413",
  E0720 = "E0720",
  BC0720 = "BC0720",
  G0720 = "G0720",
  G0524 = "G0524",
  HG0324 = "HG0324",
}
